import _slicedToArray from "/home/runner/work/armeria/armeria/site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// src/index.jsx
import React, { useEffect, useRef, useState } from "react";
import ResizeObserver from "resize-observer-polyfill";
var getScrollParent = function getScrollParent(node) {
  var parent = node;
  while (parent = parent.parentElement) {
    var overflowYVal = getComputedStyle(parent, null).getPropertyValue("overflow-y");
    if (parent === document.body) return window;
    if (overflowYVal === "auto" || overflowYVal === "scroll") return parent;
  }
  return window;
};
var offsetTill = function offsetTill(node, target) {
  var current = node;
  var offset = 0;
  if (target.firstChild && target.firstChild.offsetParent !== target) {
    offset += node.offsetTop - target.offsetTop;
    target = node.offsetParent;
    offset += -node.offsetTop;
  }
  do {
    offset += current.offsetTop;
    current = current.offsetParent;
  } while (current && current !== target);
  return offset;
};
var getParentNode = function getParentNode(node) {
  var currentParent = node.parentNode;
  while (currentParent) {
    var style = getComputedStyle(currentParent, null);
    if (style.getPropertyValue("display") !== "contents") break;
    currentParent = currentParent.parentNode;
  }
  return currentParent || window;
};
var stickyProp = null;
if (typeof CSS !== "undefined" && CSS.supports) {
  if (CSS.supports("position", "sticky")) stickyProp = "sticky";else if (CSS.supports("position", "-webkit-sticky")) stickyProp = "-webkit-sticky";
}
var passiveArg = false;
try {
  opts = Object.defineProperty({}, "passive", {
    get: function get() {
      passiveArg = {
        passive: true
      };
    }
  });
  window.addEventListener("testPassive", null, opts);
  window.removeEventListener("testPassive", null, opts);
} catch (e) {}
var opts;
var registerNode = function registerNode(node, _ref) {
  var offsetTop = _ref.offsetTop,
    offsetBottom = _ref.offsetBottom,
    bottom = _ref.bottom;
  var scrollPane = getScrollParent(node);
  var latestScrollY = scrollPane === window ? window.scrollY : scrollPane.scrollTop;
  var unsubs = [];
  var mode, offset, nodeHeight, naturalTop, parentHeight, scrollPaneOffset, viewPortHeight;
  var getCurrentOffset = function getCurrentOffset() {
    if (mode === "relative") return offset;
    if (mode === "stickyTop") {
      return Math.max(0, scrollPaneOffset + latestScrollY - naturalTop + offsetTop);
    }
    if (mode === "stickyBottom") {
      return Math.max(0, scrollPaneOffset + latestScrollY + viewPortHeight - (naturalTop + nodeHeight + offsetBottom));
    }
  };
  var changeToStickyBottomIfBoxTooLow = function changeToStickyBottomIfBoxTooLow(scrollY) {
    if (scrollY + scrollPaneOffset + viewPortHeight >= naturalTop + nodeHeight + offset + offsetBottom) {
      changeMode("stickyBottom");
    }
  };
  var changeMode = function changeMode(newMode) {
    mode = newMode;
    if (newMode === "relative") {
      node.style.position = "relative";
      if (bottom) {
        var nextBottom = Math.max(0, parentHeight - nodeHeight - offset);
        node.style.bottom = "".concat(nextBottom, "px");
      } else {
        node.style.top = "".concat(offset, "px");
      }
    } else {
      node.style.position = stickyProp;
      if (newMode === "stickyBottom") {
        if (bottom) {
          node.style.bottom = "".concat(offsetBottom, "px");
        } else {
          node.style.top = "".concat(viewPortHeight - nodeHeight - offsetBottom, "px");
        }
      } else {
        if (bottom) {
          node.style.bottom = "".concat(viewPortHeight - nodeHeight - offsetBottom, "px");
        } else {
          node.style.top = "".concat(offsetTop, "px");
        }
      }
    }
    offset = getCurrentOffset();
  };
  var initial = function initial() {
    if (bottom) {
      if (mode !== "stickyBottom") changeMode("stickyBottom");
    } else {
      if (mode !== "stickyTop") changeMode("stickyTop");
    }
  };
  var addListener = function addListener(element, event, handler, passive) {
    element.addEventListener(event, handler, passive);
    unsubs.push(function () {
      return element.removeEventListener(event, handler);
    });
  };
  var handleScroll = function handleScroll() {
    var scrollY = scrollPane === window ? window.scrollY : scrollPane.scrollTop;
    if (scrollY === latestScrollY) return;
    if (nodeHeight + offsetTop + offsetBottom <= viewPortHeight) {
      initial();
      latestScrollY = scrollY;
      return;
    }
    var scrollDelta = scrollY - latestScrollY;
    offset = getCurrentOffset();
    if (scrollDelta > 0) {
      if (mode === "stickyTop") {
        if (scrollY + scrollPaneOffset + offsetTop > naturalTop) {
          if (scrollY + scrollPaneOffset + viewPortHeight <= naturalTop + nodeHeight + offset + offsetBottom) {
            changeMode("relative");
          } else {
            changeMode("stickyBottom");
          }
        }
      } else if (mode === "relative") {
        changeToStickyBottomIfBoxTooLow(scrollY);
      }
    } else {
      if (mode === "stickyBottom") {
        if (scrollPaneOffset + scrollY + viewPortHeight < naturalTop + parentHeight + offsetBottom) {
          if (scrollPaneOffset + scrollY + offsetTop >= naturalTop + offset) {
            changeMode("relative");
          } else {
            changeMode("stickyTop");
          }
        }
      } else if (mode === "relative") {
        if (scrollPaneOffset + scrollY + offsetTop < naturalTop + offset) {
          changeMode("stickyTop");
        }
      }
    }
    latestScrollY = scrollY;
  };
  var handleWindowResize = function handleWindowResize() {
    viewPortHeight = window.innerHeight;
    scrollPaneOffset = 0;
    handleScroll();
  };
  var handleScrollPaneResize = function handleScrollPaneResize() {
    viewPortHeight = scrollPane.offsetHeight;
    if (viewPortHeight === 0) {
      console.warn("react-sticky-box's scroll pane has a height of 0. This seems odd. Please check this node:", scrollPane);
    }
    if (scrollPane.firstChild.offsetParent === scrollPane) {
      scrollPaneOffset = scrollPane.getBoundingClientRect().top;
    } else {
      scrollPaneOffset = 0;
    }
    handleScroll();
  };
  var handleParentNodeResize = function handleParentNodeResize() {
    var parentNode = getParentNode(node);
    var computedParentStyle = getComputedStyle(parentNode, null);
    var parentPaddingTop = parseInt(computedParentStyle.getPropertyValue("padding-top"), 10);
    var parentPaddingBottom = parseInt(computedParentStyle.getPropertyValue("padding-bottom"), 10);
    var verticalParentPadding = parentPaddingTop + parentPaddingBottom;
    naturalTop = offsetTill(parentNode, scrollPane) + parentPaddingTop + scrollPaneOffset;
    var oldParentHeight = parentHeight;
    parentHeight = parentNode.getBoundingClientRect().height - verticalParentPadding;
    if (mode === "relative") {
      if (bottom) {
        changeMode("relative");
      } else {
        if (oldParentHeight > parentHeight) {
          changeToStickyBottomIfBoxTooLow(latestScrollY);
        }
      }
    }
    if (oldParentHeight !== parentHeight && mode === "relative") {
      latestScrollY = Number.POSITIVE_INFINITY;
      handleScroll();
    }
  };
  var handleNodeResize = function handleNodeResize() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      initialArg = _ref2.initial;
    var prevHeight = nodeHeight;
    nodeHeight = node.getBoundingClientRect().height;
    if (!initialArg && prevHeight !== nodeHeight) {
      if (nodeHeight + offsetTop + offsetBottom <= viewPortHeight) {
        mode = void 0;
        initial();
        return;
      } else {
        var diff = prevHeight - nodeHeight;
        var lowestPossible = parentHeight - nodeHeight;
        var nextOffset = Math.min(lowestPossible, getCurrentOffset() + (bottom ? diff : 0));
        offset = Math.max(0, nextOffset);
        if (!bottom || mode !== "stickyBottom") changeMode("relative");
      }
    }
  };
  var addResizeObserver = function addResizeObserver(n, handler) {
    var ro = new ResizeObserver(handler);
    ro.observe(n);
    unsubs.push(function () {
      return ro.disconnect();
    });
  };
  addListener(scrollPane, "scroll", handleScroll, passiveArg);
  addListener(scrollPane, "mousewheel", handleScroll, passiveArg);
  if (scrollPane === window) {
    addListener(window, "resize", handleWindowResize);
    handleWindowResize();
  } else {
    addResizeObserver(scrollPane, handleScrollPaneResize);
    handleScrollPaneResize();
  }
  addResizeObserver(getParentNode(node), handleParentNodeResize);
  handleParentNodeResize();
  addResizeObserver(node, handleNodeResize);
  handleNodeResize({
    initial: true
  });
  initial();
  return function () {
    return unsubs.forEach(function (fn) {
      return fn();
    });
  };
};
var useStickyBox = function useStickyBox() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$offsetTop = _ref3.offsetTop,
    offsetTop = _ref3$offsetTop === void 0 ? 0 : _ref3$offsetTop,
    _ref3$offsetBottom = _ref3.offsetBottom,
    offsetBottom = _ref3$offsetBottom === void 0 ? 0 : _ref3$offsetBottom,
    _ref3$bottom = _ref3.bottom,
    bottom = _ref3$bottom === void 0 ? false : _ref3$bottom;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    node = _useState2[0],
    setNode = _useState2[1];
  var argRef = useRef({
    offsetTop: offsetTop,
    offsetBottom: offsetBottom,
    bottom: bottom
  });
  useEffect(function () {
    argRef.current = {
      offsetTop: offsetTop,
      offsetBottom: offsetBottom,
      bottom: bottom
    };
  });
  useEffect(function () {
    if (!node) return;
    return registerNode(node, argRef.current);
  }, [node]);
  return setNode;
};
var StickyBox = function StickyBox(_ref4) {
  var offsetTop = _ref4.offsetTop,
    offsetBottom = _ref4.offsetBottom,
    bottom = _ref4.bottom,
    children = _ref4.children,
    className = _ref4.className,
    style = _ref4.style;
  var ref = useStickyBox({
    offsetTop: offsetTop,
    offsetBottom: offsetBottom,
    bottom: bottom
  });
  return /* @__PURE__ */React.createElement("div", {
    className: className,
    style: style,
    ref: ref
  }, children);
};
var src_default = StickyBox;
export { src_default as default, useStickyBox };